"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitializationFailure = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ErrorCircleOutline_1 = __importDefault(require("@kyruus/react-ikons/ErrorCircleOutline"));
// if this component renders, we have no config to work with
// so these styles need to be universal
const InitializationFailureContainer = (0, styled_1.default)('div') `
  display: flex;
  align-items: center;
  background-color: white;
  padding: 8px;
  border-radius: 2px;

  > span {
    font-size: 18px;
    font-weight: bold;
    color: #2a3d51;
  }

  > span.icon {
    height: 32px;
    width: 32px;
    margin: 0 10px 6px 0;
  }
`;
const InitializationFailure = () => {
    return (react_1.default.createElement(InitializationFailureContainer, { "data-testid": "sw-init-failure" },
        react_1.default.createElement("span", { className: "icon" },
            react_1.default.createElement(ErrorCircleOutline_1.default, { size: '32', color: '#2a3d51' })),
        react_1.default.createElement("span", null, "Oops... Something went wrong, please refresh the page to try again.")));
};
exports.InitializationFailure = InitializationFailure;
//# sourceMappingURL=InitializationFailure.js.map